import { SHOW_TOAST, HIDE_TOAST } from '../actions/types'

const INITIAL_STATE = {
  showToast: false,
  toastMessage: '',
  toastColor: ''
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SHOW_TOAST:
      const { toastMessage, toastColor } = action.payload
      let color
      switch (toastColor) {
        case 'primary':
          color = '#0a3d62'
          break
        case 'danger':
          color = 'rgb(223, 0, 32)'
          break
        default:
          color = toastColor
          break
      }
      return { ...state, showToast: true, toastMessage, toastColor: color }
    case HIDE_TOAST:
      return { INITIAL_STATE }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/toastReducer.js